export const currencyToLabel: Record<string, string> = {
  USD: '$',
  RUB: '₽',
  UTT: 'UTT',
};
